// pattern: imperative-shell
import type { Route } from "../shell/router";
import { navigate } from "../shell/router";

const NAV_ITEMS: Array<{ route: Route; icon: string; label: string; hash: string }> = [
	{ route: "timeline", icon: "\u{1F4C5}", label: "Timeline", hash: "" },
	{ route: "new", icon: "\u{2795}", label: "Add", hash: "new" },
	{ route: "search", icon: "\u{1F50D}", label: "Search", hash: "search" },
	{ route: "locations", icon: "\u{1F4CD}", label: "Locations", hash: "locations" },
];

export function renderNavBar(container: HTMLElement, activeRoute: Route): void {
	container.innerHTML = "";
	const nav = document.createElement("nav");
	nav.className = "nav";

	for (const item of NAV_ITEMS) {
		const btn = document.createElement("button");
		btn.className = `nav-item${item.route === activeRoute ? " active" : ""}`;
		btn.innerHTML = `<span class="nav-icon">${item.icon}</span>${item.label}`;
		btn.addEventListener("click", () => navigate(item.hash));
		nav.appendChild(btn);
	}

	container.appendChild(nav);
}
